import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { NavigationModel } from '../models/navigation.model';
import { ActionModel } from '../models/action.model';
import { ToolbarButtonEnum } from '../enums/toolbar-button.enum';
import { ConnectionStatusEnum } from '../enums/connection.status.enum';
import { ThemeService } from 'ng2-charts';
import { ChartOptions } from 'chart.js';

@Injectable({
  providedIn: 'root'
})
export class UserInterfaceService {

  private sidenavLeft =  new Subject<boolean>();
  private sidenavRight = new Subject<boolean>();
  private title = new Subject<string>();
  private toolbarButton = new Subject<ToolbarButtonEnum>();
  private toolbarComponent = new Subject<NavigationModel>();
  private toolbarAction = new Subject<ActionModel>();
  private sidenavComponent = new Subject<NavigationModel>();
  private sidenavAction = new Subject<ActionModel>();
  private connectionStatus = new Subject<ConnectionStatusEnum>();
  private darkTheme = new Subject<boolean>();
  private language = new BehaviorSubject<string>(null);

  private authenticated =  new Subject<boolean>();

  constructor(private themeService: ThemeService) { }

  getSidenavLeft(): Observable<boolean> {
    return this.sidenavLeft.asObservable();
  }

  setSidenavLeft(data: boolean) {
    this.sidenavLeft.next(data);
  }

  setAuthentication(data: boolean) {
    this.authenticated.next(data);
  }

  getAuthentication(): Observable<boolean> {
    return this.authenticated.asObservable();
  }

  getSidenavRight(): Observable<boolean> {
    return this.sidenavRight.asObservable();
  }

  setSidenavRight(data: boolean) {
    this.sidenavRight.next(data);
  }

  getTitle(): Observable<string> {
    return this.title.asObservable();
  }

  setTitle(data: string) {
    this.title.next(data);
  }

  getToolbarButton(): Observable<ToolbarButtonEnum> {
    return this.toolbarButton.asObservable();
  }

  setToolbarButton(data: ToolbarButtonEnum) {
    this.toolbarButton.next(data);
  }

  setToolbarComponent(navigation: NavigationModel) {
    this.toolbarComponent.next(navigation);
  }

  getToolbarComponent(): Observable<NavigationModel> {
      return this.toolbarComponent.asObservable();
  }

  setToolbarAction(action: ActionModel) {
      this.toolbarAction.next(action);
  }

  getToolbarAction(): Observable<ActionModel> {
      return this.toolbarAction.asObservable();
  }

  setSidenavComponent(navigation: NavigationModel) {
      this.sidenavComponent.next(navigation);
  }

  getSidenavComponent(): Observable<NavigationModel> {
      return this.sidenavComponent.asObservable();
  }

  setSidenavAction(action: ActionModel) {
      this.sidenavAction.next(action);
  }

  getSidenavAction(): Observable<ActionModel> {
      return this.sidenavAction.asObservable();
  }

  getConnectionStatus(): Observable<ConnectionStatusEnum> {
    return this.connectionStatus.asObservable();
  }

  setConnectionStatus(data: ConnectionStatusEnum) {
    this.connectionStatus.next(data);
  }

  getDarkTheme(): Observable<boolean> {
    return this.darkTheme.asObservable();
  }

  setDarkTheme(data: boolean) {
    let body = document.getElementsByTagName('body')[0];
    if(data)
    {
      body.classList.remove("theme-rad-light");
      body.classList.add("theme-rad-dark");
    }
    else
    {
      body.classList.remove("theme-rad-dark");
      body.classList.add("theme-rad-light");
    }
    this.darkTheme.next(data);

    //chart theme section
    let overrides: ChartOptions;
    if (data) {
      overrides = {
        legend: {
          labels: { fontColor: 'white' }
        },
        scales: {
          xAxes: [{
            ticks: { fontColor: 'white' },
            gridLines: { color: 'rgba(255,255,255,0.1)' }
          }],
          yAxes: [{
            ticks: { fontColor: 'white' },
            gridLines: { color: 'rgba(255,255,255,0.1)' }
          }]
        }
      };
    } else {
      overrides = {};
    }
    this.themeService.setColorschemesOptions(overrides);
  }

  getLanguage(): Observable<string> {
    return this.language.asObservable();
  }

  setLanguage(data: string) {
    this.language.next(data);
  }
}
